import { BoxPlotFilled, DollarCircleFilled } from '@ant-design/icons'
import { addCommasToNumber, GraviButton, Texto } from '@gravitate-js/excalibrr'
import { Col, Row } from 'antd'
import React, { useMemo } from 'react'

export function BulkChangeBar({ selectedRows, setIsBulkChangeVisible }) {
  const totalDemand = useMemo(() => selectedRows?.reduce((a, b) => (a += b.daily_demand), 0), [selectedRows])
  if (selectedRows.length > 0) {
    return (
      <Row className='bg-theme2'>
        <Col className='vertical-flex-center px-3' flex={1} align='left'>
          <Texto appearance='white'>
            <b>
              {selectedRows.length} tank{selectedRows.length > 1 ? 's' : ''} selected to modify.
            </b>{' '}
            You can bulk remove the supply default/override - or bulk choose a default.
          </Texto>
        </Col>

        <Col className='flex items-center h-100 py-3 pr-4 justify-end'>
          <Texto align='right' category='h6' appearance='white'>
            (<b>{addCommasToNumber(totalDemand)}</b> Total Daily Demand)
          </Texto>
        </Col>
        <Col className='flex items-center h-100 py-3 justify-end'>
          <div className='tank-override-button'>
            <GraviButton
              buttonText='Choose Supply Default'
              onClick={() => setIsBulkChangeVisible(true)}
              className='mr-3'
              icon={<DollarCircleFilled />}
            />
          </div>
        </Col>
      </Row>
    )
  }
  return (
    <div className='bg-3 p-4'>
      <Texto category='h6' weight='bold' appearance='secondary'>
        <BoxPlotFilled className='pr-2' /> Select tank(s) to manage supply defaults.
      </Texto>
    </div>
  )
}
